<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on"
        ><v-icon>mdi-eye-outline</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="headline">
        バージョン詳細
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout class="row mx-1 mt-5" child-flex>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-default-header
            :items-per-page.sync="paginationItems.maxResultCount"
            :page="pagination.page"
            loading-text="読み込み中。。。待ってください。"
            hide-default-footer
            item-key="name"
            :loading="loading"
            show-expand
            class="elevation-1 width-10"
          >
            <template v-slot:top>
              <div class="header-top">
                <strong>ストーリーモード</strong>
              </div>
            </template>
            <template v-slot:expanded-item="{ item }">
              <td colspan="2">
                <v-row
                  class="my-2"
                  no-gutters
                  v-for="(itemChil, inx) in item.data"
                  :key="inx"
                >
                  <v-col cols="4">{{
                    convertDataUpdate(itemChil.updateData).updateKey
                  }}</v-col>
                  <v-col>{{
                    convertDataUpdate(itemChil.updateData).text
                  }}</v-col>
                </v-row>
              </td>
            </template>
            <template v-slot:no-data>
              <div class="text-center">データがありません。</div>
            </template>
          </v-data-table>
        </v-layout>
        <v-row class="mx-1 mt-2">
          <v-spacer />
          <BasePagination
            class="mt-5"
            :pageCount="paginationItems.pageCount"
            :pageSize="paginationItems.maxResultCount"
            @changePage="(value) => (pagination.page = value)"
          />
        </v-row>
        <v-layout class="row mx-1 mt-5" child-flex>
          <v-data-table
            :headers="headersSelfStudy"
            :items="itemDataSelfStudy"
            :items-per-page.sync="paginationDataSelfStudy.maxResultCount"
            :page="pagination.page"
            loading-text="読み込み中。。。待ってください。"
            :loading="loading"
            hide-default-header
            hide-default-footer
            class="elevation-1 width-10"
          >
            <template v-slot:top>
              <div class="header-top">
                <strong>自習</strong>
              </div>
            </template>
            <template v-slot:item.name="{ item }">
              {{ convertDataSelfStudy(item).updateKey }}
            </template>
            <template v-slot:item.text="{ item }">
              {{ convertDataSelfStudy(item).text }}
            </template>
            <template v-slot:no-data>
              <div class="text-center">データがありません。</div>
            </template>
          </v-data-table>
        </v-layout>
        <v-row class="mx-1 mt-2">
          <v-spacer />
          <BasePagination
            class="mt-5"
            :pageCount="paginationDataSelfStudy.pageCount"
            :pageSize="paginationDataSelfStudy.maxResultCount"
            @changePage="(value) => (paginationDataSelfStudy.page = value)"
          />
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { getDetailVersion } from "@/api/MasterData.api";
import mixin from "@/mixin";
import BasePagination from "@/components/Pagination/BasePagination";
export default {
  mixins: [mixin.App],
  components: { BasePagination },
  props: {
    itemId: { type: String },
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          value: "name",
          groupable: false,
        },
        { text: "", value: "data-table-expand", align: "end" },
      ],
      headersSelfStudy: [
        {
          value: "name",
        },
        { text: "", value: "text" },
      ],
      loading: false,
      items: [],
      paginationItems: { page: 1, pageCount: 0, maxResultCount: 10 },
      itemDataSelfStudy: [],
      paginationDataSelfStudy: { page: 1, pageCount: 0, maxResultCount: 10 },
    };
  },
  mounted() {},
  watch: {
    dialog: async function (val) {
      if (val) {
        await this.fetchDetailVersion();
      }
    },
  },
  methods: {
    async fetchDetailVersion() {
      const { itemId } = this;
      this.loading = true;
      let params = { id: itemId };
      await getDetailVersion(params)
        .then(({ result: { data, data_self_study } }) => {
          this.items = data;
          this.paginationItems.pageCount = data.length;
          this.itemDataSelfStudy = data_self_study;
          this.paginationDataSelfStudy.pageCount = data_self_study.length;
        })
        .catch(() => {
          this.loading = false;
        });
      this.loading = false;
    },
    convertDataUpdate(data) {
      const { _ } = this;
      let text;
      let updateKey;
      var name = "";
      _.forIn(data, function (value, key) {
        if (!_.isEmpty(value)) {
          // conversation
          if (key == "conversation") {
            updateKey = "スキット";
            text = "スキットが変更される";
          }
          // question
          else if (key == "question") {
            updateKey = "練習問題";
            text = "練習問題が変更される";
          }
          // grammar
          else if (key == "grammar") {
            updateKey = "文法解説";
            _.forEach(value.data, function (i) {
              if (i.key == "Title") {
                name += i.value.ja;
              }
            });
            text = `${name}が変更される`;
          }
          // expression
          else if (key == "expression") {
            updateKey = "表現・文型";
            _.forEach(value.data, (e) => {
              if (e.key == "FormTitle") {
                _.forEach(e.data, (i) => {
                  if (i.key == "Title") {
                    name += i.value.ja;
                  }
                });
              }
            });
            text = `${name}が変更される`;
          } else if (key == "info") {
            if (value["title"]) {
              updateKey = "セクションタイトル";
              text = "セクションタイトルが変更される";
            } else if (value["goal"]) {
              updateKey = "学習目標";
              text = "学習目標が変更される";
            } else if (value["lead_sentence"]) {
              updateKey = "リード文";
              text = "リード文が変更される";
            }
          }
        }
      });
      return { text, updateKey };
    },
    convertDataSelfStudy(data) {
      const {
        category,
        datetime,
        tab,
        vocabulary,
        badge,
        grammar,
        data: { type },
      } = data;
      let text;
      let updateKey;
      // Update category
      if (category && category != "NULL" && category != "NUL") {
        updateKey = "カテゴリ";
        text = "カテゴリが変更される";
      }
      // Update tab
      else if (tab && tab != "NULL") {
        updateKey = "タブ";
        text = "タブが変更される";
      }
      // Update vocabulary
      else if (vocabulary && vocabulary != "NULL") {
        updateKey = "単語一覧";
        text = "単語一覧が変更される";
      }
      // Update badge
      else if (badge && badge != "NULL") {
        updateKey = "単語帳バッヂ";
        text = "単語帳バッヂが変更される";
      }
      // Update grammar
      else if (grammar && grammar != "NULL") {
        updateKey = "文法解説一覧";
        text = "文法解説一覧が変更される";
      }
      // Update hour
      else if (
        datetime &&
        datetime != "NULL" &&
        (type == "HOUR" || type == "MINUTE")
      ) {
        updateKey = "時間";
        text = "時間が変更される";
      }
      // Update week
      else if (
        datetime &&
        datetime != "NULL" &&
        (type == "WEEK" || type == "DAY" || type == "MONTH")
      ) {
        updateKey = "日付";
        text = "日付が変更される";
      }
      return { text, updateKey };
    },
  },
};
</script>
<style scoped>
::v-deep .v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
::v-deep tr.v-data-table__expanded.v-data-table__expanded__row {
  background: #eeeeee;
}
.header-top {
  display: flex;
  justify-content: center;
  min-height: 40px;
  align-items: center;
  border-bottom: 1px solid #cccccc;
  background: #e0e0e0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
</style>